import { call, put, takeEvery, select, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import {
    fetchUserProfileFailure,
    fetchUserProfileSuccess,
} from "../actions";
import {
    fetchProfileURL,
    postRatingAPI,
    deleteRatingAPI
} from "../../API/API";

function* postRatingSaga(request) {
    try {
        const response = yield call(() => postRatingAPI(request.payload)); // API Backend
        yield put({ type: types.POST_RATING_SUCCESS, payload: response.data });
    }
    catch (error) {
        yield put({ type: types.POST_RATING_FAILURE, error });
    }
};

function* deleteRatingSaga(request) {
    try {
        const response = yield call(() => deleteRatingAPI(request.payload)); // API Backend
        yield put({ type: types.DELETE_RATING_SUCCESS, payload: response.data });
    }
    catch (error) {
        yield put({ type: types.DELETE_RATING_FAILURE, error });
    }
};

export function* watchRatingSaga() {
    yield takeLeading(types.POST_RATING_REQUESTED, postRatingSaga);
};
export function* watchDeleteRatingSaga() {
    yield takeLeading(types.DELETE_RATING_REQUESTED, deleteRatingSaga);
};
